<template>
  <section id="calculator" class="container">
    <h4>Simple Calculator</h4>
    <p>
      Welcome to my simple calculator. It does simple addition, subtraction,
      multiplication, and division. Why might you ask did I create this? First,
      to create a simple javascript exercise. Second, to eliminate a minor
      annoyance with some calculations in my day-to-day work life.
    </p>
    <h6>The Scenario</h6>
    <p>
      Imagine if you will, having to verify several pages of data calculations
      manually. These calculations look something like this: 1.15 * 3.52 = 4.013
      * 50000 / 100 = 2006.500 + (9.7 * 3.735) = 2,042.73. I lost about 2 or 3
      seconds at each equal sign retyping with the precision to make sure the
      math was correct based on the precisions used.
    </p>
    <form class="calc-form" @submit.prevent="calculate">
      <div class="form-row align-items-center">
        <div class="col-sm-6 my-1">
          <label for="calc-input">Calculation</label>
          <input
            type="text"
            class="form-control"
            id="calc-input"
            ref="calcInput"
            @keypress="validateCalc($event)"
            @keypress.enter="calculate"
          />
        </div>
        <div class="col-sm-3 my-1">
          <label for="calc-precision">Precision</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              id="calc-precision"
              ref="calcPrecision"
              @keypress="validatePrecision($event)"
              @keypress.enter="calculate"
              maxlength="1"
            />
          </div>
        </div>
      </div>
      <div class="form-row align-items-center">
        <div class="col-auto my-1">
          <button type="submit" class="btn btn-primary calc" @click="calculate">Calculate</button>
        </div>
        <div class="col-auto my-1">
          <button type="submit" class="btn btn-secondary reset" @click="reset">Reset</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: "calculator",
  data() {
    return {};
  },
  methods: {
    calculate() {
      const calcField = this.$refs.calcInput;
      let calculatedValue = eval(calcField.value);
      let precisionValue = this.$refs.calcPrecision.value;
      if (!isNaN(calculatedValue)) {
        if (!isNaN(precisionValue) && precisionValue !== "") {
          calcField.value = calculatedValue.toFixed(precisionValue);
        } else {
          calcField.value = calculatedValue;
        }
      }
    },
    validateCalc(event) {
      // eslint-disable-next-line no-useless-escape
      var regex = new RegExp("^[0-9-%*\(\)\+\.\/]");
      var key = String.fromCharCode(
        event.charCode ? event.which : event.charCode
      );
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    validatePrecision(event) {
      var regex = new RegExp("^[0-9]");
      var key = String.fromCharCode(
        event.charCode ? event.which : event.charCode
      );
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    reset() {
      this.$refs.calcInput.value = "";
      this.$refs.calcPrecision.value = "";
    }
  }
};
</script>
